import * as React from "react";
import * as ReactDOM from "react-dom/client";
import Filters from "./components/filters";

const rootElement = document.getElementById("sata-search-filters");

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  const lang =
    rootElement.getAttribute("data-lang") || window.navigator?.language || "fr";

  root.render(
    <React.StrictMode>
      <Filters lang={lang} />
    </React.StrictMode>
  );
} else {
  console.error(
    "rootElement not found. You must place an element with the id `sata-search-filters` in your web page in order to inject this widget."
  );
}
